import { put } from 'redux-saga/effects';
import PersonsActions from '../redux/PersonsRedux';
import i18n from '../i18n';
import decode from 'jwt-decode';

export function* getPersons(api, { customerId, pageParams }) {
  try {
    const getPersonsResponse = yield api.getPersons(customerId, pageParams);
    if (getPersonsResponse.ok) {
      const personsWithSub = getPersonsResponse.data.content.map((person) => ({
        ...person,
        sub: decode(person.personId)?.sub,
      }));
      yield put(PersonsActions.getPersonsRequestSuccess(personsWithSub, getPersonsResponse.data.totalElements));
    } else {
      api.checkAuth(getPersonsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getPersonsResponse.problem !== 'undefined'
          ? getPersonsResponse.problem
          : typeof getPersonsResponse.data.error !== 'undefined'
          ? getPersonsResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(PersonsActions.getPersonsRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(PersonsActions.getPersonsRequestFailure(error));
  }
}

export function* createPerson(api, { personInfos, customerId, pageParams }) {
  try {
    const createPersonResponse = yield api.createPerson(personInfos);
    const getPersonsResponse = yield api.getPersons(customerId, pageParams);
    const successMessage = i18n.t('successMessage.createPersonSuccess');
    if (createPersonResponse.ok && getPersonsResponse.ok) {
      yield put(
        PersonsActions.createPersonRequestSuccess(
          createPersonResponse.data[0]['personId'],
          createPersonResponse.data[0]['address']['addressId'],
          createPersonResponse.data[0]['address']['email'],
          getPersonsResponse.data.content,
          getPersonsResponse.data.totalElements,
          successMessage,
        ),
      );
    } else {
      api.checkAuth(createPersonResponse);
      api.checkAuth(getPersonsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createPersonResponse.problem !== 'undefined'
          ? createPersonResponse.problem
          : typeof createPersonResponse.data.error !== 'undefined'
          ? createPersonResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(PersonsActions.createPersonRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(PersonsActions.createPersonRequestFailure(error));
  }
}

export function* editPerson(api, { personInfos }) {
  try {
    const editPersonResponse = yield api.editPerson(personInfos);
    const successMessage = i18n.t('successMessage.editPersonSuccess');
    if (editPersonResponse.ok) {
      yield put(PersonsActions.editPersonRequestSuccess(editPersonResponse.data, editPersonResponse?.data?.address?.email, successMessage));
    } else {
      api.checkAuth(editPersonResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editPersonResponse.problem !== 'undefined'
          ? editPersonResponse.problem
          : typeof editPersonResponse.data.error !== 'undefined'
          ? editPersonResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(PersonsActions.editPersonRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(PersonsActions.editPersonRequestFailure(error));
  }
}

export function* deletePerson(api, { personId, customerId, pageParams }) {
  try {
    const deletePersonResponse = yield api.deletePerson(personId, customerId);
    console.log('deletePersonResponse:', deletePersonResponse);
    const getPersonsResponse = yield api.getPersons(customerId, pageParams);
    const successMessage = i18n.t('successMessage.deletePersonSuccess');
    if (deletePersonResponse.ok && getPersonsResponse.ok) {
      yield put(
        PersonsActions.deletePersonRequestSuccess(
          getPersonsResponse.data.content,
          getPersonsResponse.data.totalElements,
          successMessage,
        ),
      );
    } else {
      api.checkAuth(deletePersonResponse);
      api.checkAuth(getPersonsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deletePersonResponse.problem !== 'undefined'
          ? deletePersonResponse.problem
          : typeof deletePersonResponse.data.error !== 'undefined'
          ? deletePersonResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(PersonsActions.deletePersonRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(PersonsActions.deletePersonRequestFailure(error));
  }
}
